import React from 'react';

/**
 * MapEmbed Component
 * Embeds Google Maps with company locations
 *
 * Note: This uses a placeholder iframe. In production, replace with actual Google Maps embed code:
 * 1. Go to Google Maps
 * 2. Search for your location
 * 3. Click "Share" > "Embed a map"
 * 4. Copy the iframe src and paste below
 */
const MapEmbed = () => {
  // Sample Google Maps embed URL
  // Replace with actual location: "서울특별시 강남구 테헤란로 123"
  const mapSrc = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3165.2506193487383!2d127.02854631559498!3d37.49794997981076!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357ca15a4c1953d7%3A0xf03bf310e8ec7be1!2z7ISc7Jq47Yq567OE7IucIOqwleuCqOq1rCDtFZ1G2ZON64-EIDEyMw!5e0!3m2!1sko!2skr!4v1234567890123!5m2!1sko!2skr";

  return (
    <div className="w-full">
      {/* Map Container */}
      <div className="relative w-full h-64 md:h-96 lg:h-[450px] rounded-lg overflow-hidden shadow-lg">
        <iframe
          src={mapSrc}
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Company Location Map"
          className="absolute top-0 left-0 w-full h-full"
        ></iframe>
      </div>

      {/* Map Attribution */}
      <p className="text-xs text-gray-500 mt-2 text-center">
        Google Maps에서 정확한 위치를 확인하실 수 있습니다
      </p>
    </div>
  );
};

export default MapEmbed;
